// Convert SRT to VTT format
export const srtToVtt = (srtText) => {
    let vtt = 'WEBVTT\n\n';
    const lines = srtText.split(/\r?\n/);
    let i = 0;
    while (i < lines.length) {
        const line = lines[i].trim();
        if (line && !isNaN(line)) {
            // Skip sequence number
            i++;
            if (i < lines.length) {
                const timecode = lines[i].trim();
                if (timecode.includes('-->')) {
                    // Convert timecode format from SRT to VTT (replace comma with dot)
                    const vttTimecode = timecode.replace(',', '.');
                    vtt += vttTimecode + '\n';
                    i++;
                    let text = '';
                    while (i < lines.length && lines[i].trim()) {
                        text += lines[i].trim() + '\n';
                        i++;
                    }
                    vtt += text + '\n';
                }
            }
        }
        i++;
    }
    return vtt;
};

// Extract S3 path from caption URL
export const extractS3PathFromUrl = (url) => {
    if (!url) return null;
    try {
        // URL format: https://dam.dev.mediapulse.io/private/processed/{cognito_id}/{file_id}/captions/Captions_{lang}.{ext}
        // Extract the path after /private/
        const urlObj = new URL(url);
        const pathname = urlObj.pathname;
        // Remove leading /private/ to get S3 key
        if (pathname.startsWith('/private/')) {
            return pathname.substring(1); // Remove leading slash
        }
        return null;
    } catch (error) {
        console.error('Error extracting S3 path:', error);
        return null;
    }
};

